const YOUTUBE_HOSTS = new Set(['youtube.com', 'www.youtube.com', 'm.youtube.com']);

/** Parses common YouTube watch, share, live, shorts and embed URLs into a video id. */
export const youtubeVideoIdFromUrl = (url: string): string | null => {
  const trimmed = url.trim();
  if (!trimmed) return null;

  let parsed: URL;
  try {
    parsed = new URL(trimmed);
  } catch {
    return null;
  }

  const host = parsed.hostname.toLowerCase();
  if (host === 'youtu.be') {
    const id = parsed.pathname.split('/').find(Boolean);
    return id && id.length > 0 ? id : null;
  }

  if (YOUTUBE_HOSTS.has(host)) {
    const queryId = parsed.searchParams.get('v');
    if (queryId) return queryId;

    const segments = parsed.pathname.split('/').filter(Boolean);
    if (segments[0] === 'embed' || segments[0] === 'live' || segments[0] === 'shorts') {
      return segments[1] && segments[1].length > 0 ? segments[1] : null;
    }
  }

  return null;
};

export const youtubeEmbedUrl = (url: string): string | null => {
  const id = youtubeVideoIdFromUrl(url);
  if (!id) return null;
  return `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}`;
};
